<template>
  <div class="dan">
    <div class="main">
      <span class="dan-name">{{ data.name }}</span>
      <template v-for="(item, index) in data.childDans">
        <span :key="index" class="sub-dan" :class="{ checked: checked(item) }" v-if="parseInt(item) != 0" @click="handleClick(data.name, item, data.starCount, data.values[index], data.level)">
          {{ item }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data', 'selectedDans'],
    name: 'dan',
    methods: {
      handleClick(dan, subDan, starCount, label, level) {
        this.$emit('selected', {
          dan: dan,
          subDan: subDan,
          starCount: starCount,
          label: label,
          level: level,
          count: 1,
        });
      },
      checked(subDan) {
        let index = this.selectedDans.findIndex(x => {
          return x.dan === this.data.name && x.subDan === subDan;
        });

        if (index === -1) {
          return false;
        } else {
          return true;
        }
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .dan
    margin 5px
    display flex
    text-align center
    .main
      display flex
      width 350px
      .dan-name,.sub-dan
        height 30px
        line-height 30px
        width 40px
        border 1px solid gray
        margin 5px
      .checked
        background-color #409EFF
        color #FFF
    .star
      display blcok
      .star-num
        width 100px
</style>
